import { Component } from '@angular/core'

@Component({
  selector: 'se-po-country-select-docs',
  templateUrl: './country-select-docs.component.html',
  styleUrls: ['./country-select-docs.component.scss'],
  standalone: false,
})
export class CountrySelectDocsComponent {
}
